import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["py-2 px-4 rounded-md mr-2 mb-2 text-sm", _ctx.muted ? 'bg-gray-200 text-gray-500' : 'bg-blue-200 text-sky'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}